import { render, staticRenderFns } from "./CardDocuments.vue?vue&type=template&id=5ca21e68&scoped=true&"
import script from "./CardDocuments.vue?vue&type=script&lang=ts&"
export * from "./CardDocuments.vue?vue&type=script&lang=ts&"
import style0 from "./CardDocuments.vue?vue&type=style&index=0&id=5ca21e68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca21e68",
  null
  
)

export default component.exports